import api from './api';

// Create checkout session and redirect
export const createCheckoutSession = async (packageId) => {
  try {
    const response = await api.post('/payment/create-checkout-session', {
      packageId
    });

    // Direkt zur Stripe Checkout URL redirecten (neue Methode!)
    window.location.href = response.data.url;

  } catch (error) {
    console.error('Checkout error:', error);
    throw error;
  }
};

export default {
  createCheckoutSession
};
